var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancleBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9477 4.63355C15.1715 4.85729 15.1902 5.2084 15.0038 5.45342L14.9479 5.51743L10.6764 9.79034L14.9504 14.0643C15.1944 14.3083 15.1944 14.7041 14.9504 14.9481C14.7266 15.1719 14.3755 15.1905 14.1305 15.0041L14.0665 14.9481L9.79256 10.6742L5.52218 14.947C5.27815 15.1911 4.88238 15.1913 4.6383 14.9472C4.41456 14.7234 4.3958 14.3723 4.5822 14.1273L4.63812 14.0633L8.90867 9.79034L4.63716 5.51882C4.39308 5.27474 4.39308 4.87902 4.63716 4.63494C4.8609 4.4112 5.21206 4.39255 5.45704 4.579L5.52104 4.63494L9.79256 8.90645L14.0639 4.63373C14.3079 4.3896 14.7037 4.38947 14.9477 4.63355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancleBlack);
export default __webpack_public_path__ + "static/media/icon-cancle-black.42d9cda1eb0bce7417412b7438691205.svg";
export { ForwardRef as ReactComponent };